import { render, staticRenderFns } from "./EnrolleeSlip.vue?vue&type=template&id=47f5301c&scoped=true&"
import script from "./EnrolleeSlip.vue?vue&type=script&lang=js&"
export * from "./EnrolleeSlip.vue?vue&type=script&lang=js&"
import style0 from "./EnrolleeSlip.vue?vue&type=style&index=0&id=47f5301c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f5301c",
  null
  
)

export default component.exports